import axios from 'axios';

export class AvailableDetailService {
    /**
     * Función que consulta el back para obtener la información
     * que se muesta en la pantalla "Disponible detalle".
     * @param emisoraStr String con el cual se busca
     *                   Si viene vacío trae todos los datos
     * @returns {Promise<unknown>} Lista con la información a mostrar.
     */
    getAvailableDetailPTM(emisoraStr) {
        return axios.get('/appapv/getAvailableDetailPTM.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                emisora: emisoraStr,
            }
        }).then(res => res.data);
    }
}